import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n/I18nContext";

export default function CookieBanner() {
  const { t } = useI18n();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("beg_cookie")) setShow(true);
  }, []);

  const dismiss = () => { localStorage.setItem("beg_cookie", "ok"); setShow(false); };
  if (!show) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[60] p-4" data-testid="cookie-banner">
      <div className="mx-auto max-w-3xl bg-white rounded-2xl shadow-[0_16px_48px_rgba(44,48,48,0.18)] border border-black/5 p-5 flex flex-col sm:flex-row items-center gap-4">
        <p className="text-sm text-ink-600 font-body flex-1">{t("cookie.text")}</p>
        <div className="flex gap-2 shrink-0">
          <Link to="/confidentialite" onClick={dismiss} data-testid="cookie-learn-more" className="px-4 py-2 rounded-full text-sm border border-ink-400/30 text-ink-600 hover:bg-black/5">{t("cookie.refuse")}</Link>
          <button onClick={dismiss} data-testid="cookie-accept" className="px-5 py-2 rounded-full text-sm bg-brand text-white hover:bg-brand-600">{t("cookie.accept")}</button>
        </div>
      </div>
    </div>
  );
}
